angular.module('impactx.deliverynote').controller('ChangeItemDeliveryDateDialogController', [
    '$scope',
    '$mdDialog',
    'items',
    'dnhId',
    'trns',
    'arrivalDate',
    'themeFactory',
    'TranslationService',
    'dataGen',
    'ToastService',
    ChangeItemDeliveryDateDialogController]);

function ChangeItemDeliveryDateDialogController($scope, $mdDialog, items, dnhId, trns, arrivalDate, themeFactory, TranslationService, dataGen, ToastService)
{
    $scope.title = trns.changeItemDeliveryDate;
    $scope.saveLabel = TranslationService.get('save');
    $scope.abortLabel = TranslationService.get('abort');
    $scope.theme = themeFactory.getTheme();
    $scope.arrivalDate = arrivalDate;

    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.answer = function () {
        if (items) {
            const selectedIds = [];
            angular.forEach(items, function (item) {
                if (item) {
                    selectedIds.push(item.id);
                }
            })

            dataGen.postAsForm($scope, {ids: selectedIds, dnhId: dnhId, newArrivalDate: arrivalDate}, "/deliverynote/changeItemDeliveryDate").then(function () {
                ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                $mdDialog.hide();
            });
        }
    };
}